import { createContext, useContext } from "react";

type SidebarContextType = {
  toggleSidebar: () => void;
};

export const SidebarContext = createContext<SidebarContextType | null>(null);

export const useSidebarToggle = () => {
  const ctx = useContext(SidebarContext);
  return ctx?.toggleSidebar;
};
